<template>
    <div class="explainClass">
        <img src="explain.png" style="object-fit: contain;height: 100vh;"/>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.explainClass {
    overflow: hidden;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
</style>